module.exports = __webpack_public_path__ + "static/images/excel.3uIJHS_.svg";